import { baseUrl } from "../../libs/env";
import React from "react";
import { imageURl } from "../../libs/env";
import { Col } from "reactstrap";
export const getDomainUrl = () => `${window.location.origin}`;


export function Header({
  data,
  assessmentStarted,                        
  click,
  getStudentid,
}) {
  let params = new URL(document.location).searchParams;
  let book_id = params.get("book_id");
  let exercise_page_number = params.get("e-p-n");
  let show_exercises = params.get("s-e");
  let search = params.get("search");
  let st_c_t_c = params.get("st_c_t_c");
  let st_le_c = params.get("st_le_c");
  let ex_b_c = params.get("ex_b_c");
  let st_th_c = params.get("st_th_c");
  let st_fn_c = params.get("st_fn_c");
  let st_gr_c = params.get("st_gr_c");
  let exercise_page_no = params.get("e-p-n");
  let student_level = params.get("level");
  let content_type = params.get("type");

  let get_tab = params.get("tab");
  let student_assignment_page_number = params.get(
    "student_assignment_page_number"
  );
  let show_assignment_list = params.get("show_assignment_list");
  let start_date = params.get("start_date");
  let end_date = params.get("end_date");
  let status = params.get("status");
  let exercise_prompt_content = params.get("exercise_prompt_content");
  let task_type = params.get("task_type");
  let student = params.get("student");
  let level = params.get("level");
  let deadline = params.get("deadline");
  let student_name = params.get("student_name");
  let homework_tab_query_string = `student_name=${student_name}&show_assignment_list=${show_assignment_list}&student_assignment_page_number=${student_assignment_page_number}&start_date=${start_date}&end_date=${end_date}&status=${status}&exercise_prompt_content=${exercise_prompt_content}&task_type=${task_type}&student=${student}&level=${level}&deadline=${deadline}`;
  let redirect = params.get("redirect");
  let book_section_id = params.get("section-id");
  let book_chapter_id = params.get("chapter-id");

  let href = null;
  let query_string;
  if (redirect === "grading") {
    href = `${baseUrl}/school/school-quiz-grading/${getStudentid}?level=${student_level}&e-p-n=${exercise_page_no}`;
  } else if (redirect === "book") {
    query_string = `section-id=${book_section_id}&chapter-id=${book_chapter_id}`
    href = `${baseUrl}/school/book/${book_id}?${query_string}`;
  } else if (redirect === "exercises") {
    query_string = `e-p-n=${exercise_page_number}&s-e=${show_exercises}&reset=false`
    if(search){
      query_string = `${query_string}&search=${search}`;
    }
    if(st_c_t_c){
      query_string = `${query_string}&st_c_t_c=${st_c_t_c}`;
    }
    if(st_le_c){
      query_string = `${query_string}&st_le_c=${st_le_c}`;
    }
    if(ex_b_c){
      query_string = `${query_string}&ex_b_c=${ex_b_c}`;
    }
    if(st_th_c){
      query_string = `${query_string}&st_th_c=${st_th_c}`;
    }
    if(st_fn_c){
      query_string = `${query_string}&st_fn_c=${st_fn_c}`;
    }
    if(st_gr_c){
      query_string = `${query_string}&st_gr_c=${st_gr_c}`;
    }
    if(content_type){
      query_string = `${query_string}&type=${content_type}`;
    }
    href = `${baseUrl}/school/exercises?${query_string}`;
  } else if (redirect === "home") {
    href = `${baseUrl}/school/home`;
  } else if (redirect === "school_assignments") {
    if (get_tab) {
      href = `${baseUrl}/school/${get_tab}?${homework_tab_query_string}`;
    }
  }
  return (
    <div class="col-12 d-flex px-0 d-none">
      <Col className="px-0 col-6">
        <img 
          src={`${imageURl}/favicon.png`}
          className="img-size"
          alt=""
        />
      </Col>
      {/* <div className="col-6 d-flex justify-content-end col-md">
        {data&&data.user_type === AccountType.STUDENT ?(
          <>
            {data && data.type === "Assessment" ?(
              <>
              {assessmentStarted || data && data.status !== "New"  ?(
                <>
                <Col className="lg-display text-end align-self-center justify-content-end px-0">
                  <button type="button" class="btn"
                    onClick={click}>
                  Help
                  </button>
                  <button type="button" class="btn"
                    onClick={click}>
                  Close
                  </button>
                </Col>
                <Col md className="sm-display text-end align-self-center px-2">
                  <SuggestedTime time={data.time_allowed_in_minutes} />
                </Col>
                </>
              ):(
                <Col className="text-end align-self-center justify-content-end px-0">
                  <button type="button" class="btn"
                    onClick={click}>
                  Help
                  </button>
                  <button type="button" class="btn"
                    onClick={click}>
                  Close
                  </button>
                </Col>
              )}
              </>
            ):(
              <>
              <Col className="lg-display text-end align-self-center justify-content-end px-0">
                <button type="button" class="btn"
                  onClick={click}>
                Help
                </button>
                <button type="button" class="btn"
                  onClick={click}>
                Close
                </button>
              </Col>
              <Col md className="sm-display text-end align-self-center px-2">
                <SuggestedTime time={data.recom_time} />
              </Col>
              </>
            )}
         </>
        ): (
          <>
           <Col className=" lg-display text-end align-self-center px-0 justify-content-end">
              <a href={href} className="pe-3 help-link" >
              Help
              </a>
              <a href={href} className="ps-2 help-link">
              Close
              </a>
            </Col>
            <Col md className="sm-display text-end align-self-center px-2">
              <SuggestedTime time={data.recom_time} />
            </Col>
          </>
        )}
      </div> */}

    </div>
  );
}
